import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-account-credit-success-dialog",
  templateUrl: "./account-credit-success-dialog.component.html",
  styleUrls: ["./account-credit-success-dialog.component.scss"]
})
export class AccountCreditSuccessDialogComponent implements OnInit
{

  constructor(
    public dialogRef: MatDialogRef<AccountCreditSuccessDialogComponent>
  ) { }

  ngOnInit(): void
  {
  }
}
